import React, { useState } from "react"
import styled from "styled-components"
import { breakpoint, color, transition } from "../../configs/utilities"
import DialogTitle from "@mui/material/DialogTitle"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import Button from "@mui/material/Button"
import hljs from "highlight.js"

const AwardShareButton = ({ award, mover }) => {
  const [open, setOpen] = useState(false)
  const [copyText, setCopyText] = useState("Copy")
  const defaultCopyText = "Copy"

  const isStateAward = () => {
    return !award.city
  }

  const share = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const copy = () => {
    navigator.clipboard.writeText(generateShareContent())
    setCopyText("Copied!")

    setTimeout(() => {
      setCopyText(defaultCopyText)
    }, 1000)
  }

  const awardLink = isStateAward()
    ? `${process.env.GATSBY_BASE_URL}/states/${award.state.slug}/`
    : `${process.env.GATSBY_BASE_URL}/movers/${award.state.slug}/${award.city.slug}/`

  const generateShareContent = () => {
    return `
    <p style="display: block;">
        <a 
          href="${awardLink}" 
          style="display: block; text-align: center; text-decoration: none;"
        >
          <img 
              src="${award.publicImageUrl}" 
              alt="${mover.name} - Award" 
              width="300"
          />
        </a>
        <span style="text-align: center; display: block; font-size: 16px; margin-top: 15px;">
            ${mover.name}
        </span>
    </p>`
  }

  const highlightedCode = hljs.highlight(generateShareContent(), {
    language: "xml",
  }).value

  return (
    <Wrapper>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
        <DialogTitle>Embed:</DialogTitle>
        <DialogContent>
          <ShareContent>
            <pre
              className={"hljs language-xml"}
              dangerouslySetInnerHTML={{ __html: highlightedCode }}
            />
            <CopyButton variant="outlined" onClick={copy}>
              {copyText}
            </CopyButton>
          </ShareContent>
        </DialogContent>
      </Dialog>

      <ShareButton onClick={share}>Share</ShareButton>
    </Wrapper>
  )
}

export default AwardShareButton

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    outline: none;
  }
`

const ShareButton = styled.div`
  cursor: pointer;
  padding: 5px 15px;
  background: ${color.gray};
  color: ${color.sand};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  text-transform: capitalize;
  border-radius: 8px;
  transition: ${transition.default};

  &:hover {
    opacity: 0.8;
  }

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 5vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 6px 10px;
    font-size: 14px;
    min-width: 100px;
    max-width: 350px;
  }
`

const ShareContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 10px;
`

const CopyButton = styled(Button)`
  max-width: 200px;
  align-self: center;
`
